<template>
  <footer class="site-footer">
    <div class="pattern"></div>
    <div class="wrap">
      <div class="top">
        <div class="brand-block">
          <div class="logo">
            <img
              src="/assets/logos/HYBRID-ISLAND-RACE-LOGO-BLANCO.svg"
              alt="Hybrid Island Race"
              style="width: 220px; height: auto; display: block"
            />
          </div>
          <p class="brand-desc">
            Menorca · Plaça des Born · 3 de octubre de 2026. La primera carrera híbrida de la isla.
          </p>
        </div>
        <div class="col">
          <h4>Carrera</h4>
          <a href="#format">El formato</a>
          <a href="#pruebas">Las 10 pruebas</a>
          <a href="#schedule">Programa</a>
          <a :href="REGISTRATION_URL" target="_blank" rel="noopener">Inscripción</a>
        </div>
        <div class="col">
          <h4>Organización</h4>
          <a href="https://gimnascanostra.com/">Gimnàs Ca Nostra</a>
          <a :href="REGISTRATION_URL">Elitechip</a>
        </div>
        <div class="col">
          <h4>Contacto</h4>
          <a href="mailto:contacto@elitechip.net">contacto@elitechip.net</a>
          <a href="tel:+34676035552">+34 676 03 55 52</a>
          <a href="https://www.instagram.com/hybridislandrace/">Instagram</a>
        </div>
      </div>
      <div class="bottom">
        <span>© 2026 HYBRID ISLAND RACE · MENORCA</span>
        <span>HYBRIDISLANDRACE.COM</span>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { REGISTRATION_URL } from '@/registration'
</script>

<style scoped>
.brand-desc {
  color: rgba(255,255,255,0.7);
  margin: 0;
  font-size: 14px;
  line-height: 1.6;
}
</style>
